/**
 * Theme initialization script.
 * This script runs synchronously before the page renders to prevent
 * flash of wrong theme (FOUC).
 *
 * IMPORTANT: This file must be loaded synchronously (no defer/async)
 * in the <head> or at the start of <body> before any visible content.
 */

(function initTheme(): void {
  let darkMode = true;
  try {
    const stored = localStorage.getItem('ic_dark_mode_enabled');
    if (stored === 'false') {
      darkMode = false;
    }
  } catch {
    // localStorage not available, use default
  }
  document.body.className = (darkMode ? 'theme-dark' : 'theme-light') + ' ' + document.body.className;
})();
